<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5n7cjV/tc-custom/9781633410008.jpg?1729938046636" alt="This image is the cover for the book H.P. Lovecraft & the Black Magickal Tradition"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">H.P. Lovecraft & the Black Magickal Tradition
      </h1>
      <p class="bookDescription body article font2">
        <b>A Lovecraft scholar presents a penetrating study of the author’s life, work, and connections to modern occultism.</b><br/><br/>Many practicing occultists have speculated that H. P. Lovecraft possessed in-depth knowledge of black magick. Yet literary scholars maintain the renowned horror writer was simply a master of his craft, and that the enduring power of his work is purely the result of his rich imagination.<br/><br/>In <i>H.P. Lovecraft &amp; the Black Magical Tradition</i>, John L. Steadman examines the considerable overlap between the author’s fictions and true occultism—and consider whether Lovecraft was a practitioner of the dark arts himself.<br/><br/>Weaving Lovecraft’s biography together with literary criticism and modern magickal systems, Steadman demonstrates that Lovecraft’s works—specifically his Cthulhu Mythos and his creation of the Necronomicon—represent the basis for a legitimate magickal system.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John L. Steadman
      </h2>
      
      <p class="authorDescription body article">John L. Steadman is a scholar of H. P. Lovecraft and western occultism and has been a magickal practitioner for more than thirty years. He is currently a college English professor at Olivet College in Michigan. Visit him at www.johnlsteadman.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weiser Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?258c99d2